import React, { FC } from 'react';
import styles from '../index.module.css';
import * as translations from '../strings';
import { getLangKey } from '../../../../models/Language';
import { Input, Button, Space, Alert } from 'antd';
import { handleCopy } from '../../../../utils/handleCopy';

const strings = translations[getLangKey()];

type Props = {
  shareLink: string;
  isShareDeliverable: boolean;
  isGuest?: boolean;
};

export const GuestInvite: FC<Props> = ({
  shareLink,
  isShareDeliverable,
  isGuest
}) => {
  const loading = shareLink === '';

  return (
    <div>
      <h2 className={styles.header}>
        {isShareDeliverable ? strings.shareFile : strings.shareWebsite}
      </h2>
      <Space.Compact className={styles.space}>
        <Input
          className={styles.shareLink}
          readOnly
          value={shareLink}
          data-cy="share-link-input"
        />
        <Button
          type="primary"
          shape="round"
          loading={loading}
          onClick={() =>
            handleCopy({
              text: shareLink,
              successMessage: strings.copiedToClipboard
            })
          }
        >
          {strings.copy}
        </Button>
      </Space.Compact>
      <Alert
        className={styles.anyoneWithLink}
        message="Anyone with the link can join this project as a Client."
        type="info"
        showIcon
      />
    </div>
  );
};
